const moduleMap = {
	"./Users": () => {
		return Promise.all([__webpack_require__.e(6828), __webpack_require__.e(4929), __webpack_require__.e(5758), __webpack_require__.e(773), __webpack_require__.e(6540), __webpack_require__.e(1655), __webpack_require__.e(4914), __webpack_require__.e(7858), __webpack_require__.e(9422)]).then(() => (() => ((__webpack_require__(4434)))));
	},
	"./Role": () => {
		return Promise.all([__webpack_require__.e(4914), __webpack_require__.e(7858), __webpack_require__.e(2897)]).then(() => (() => ((__webpack_require__(2897)))));
	},
	"./Profile": () => {
		return Promise.all([__webpack_require__.e(6828), __webpack_require__.e(9564), __webpack_require__.e(4929), __webpack_require__.e(5758), __webpack_require__.e(773), __webpack_require__.e(6540), __webpack_require__.e(1655), __webpack_require__.e(4914), __webpack_require__.e(7858), __webpack_require__.e(9014), __webpack_require__.e(3491)]).then(() => (() => ((__webpack_require__(4631)))));
	},
	"./Queue": () => {
		return Promise.all([__webpack_require__.e(4914), __webpack_require__.e(7858), __webpack_require__.e(1216)]).then(() => (() => ((__webpack_require__(1216)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});